export const discounRates = [
    {
        name: 'Välj rabattsats',
        value: 0
    },
    {
        name: '-5% rabatt',
        value: 5
    },
    {
        name: '-10% rabatt',
        value: 10
    },
    {
        name: '-20% rabatt',
        value: 20
    },
    {
        name: '-30% rabatt',
        value: 30
    },
    {
        name: '-40% rabatt',
        value: 40
    },
    {
        name: '-50% rabatt',
        value: 50
    },
    {
        name: '-60% rabatt',
        value: 60
    },
    {
        name: '-70% rabatt',
        value: 70
    }
];
